// automations/index.js — routes for automation library + editor
import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import AutomationsList from './automationsList.js';
import AutomationEditor from './automationEditor.js';

const Automations = ({ match }) => (
  <Switch>
    <Route exact path={`${match.url}`} component={AutomationsList} />
    <Route exact path={`${match.url}/new`} component={AutomationEditor} />
    <Route exact path={`${match.url}/:id/edit`} component={AutomationEditor} />
    <Redirect to={`${match.url}`} />
  </Switch>
);

export default Automations;
